<div class="cell">
  <div class="chip chip--du">
    <span className="{{ AusResultStatusIcon[(ausResult$ | async).duResult ?? AusResult.Incomplete] }} px-1 mx-1"></span><span class="text">DU</span>
  </div>
  @if ((isShowLpa$ | async) === true) {
    <div class="chip">
      <span className="{{ LpaResultStatusIcon[(ausResult$ | async).lpaResult ?? LpaResult.Incomplete] }} px-1 mx-1"></span
      ><span class="text">LPA</span>
    </div>
  }
  <div class="chip chip--ea ms-1">
    <span className="{{ AusResultStatusIcon[(ausResult$ | async).eaResult ?? AusResult.Incomplete] }} px-1 mx-1"></span
    ><span class="text">DU EA</span>
  </div>
</div>
